<template>
    <div v-if="showBanner" class="background-overlay flex items-center justify-center">
        <div
            class="flex-col sm:flex-row z-50 right-5 max-sm:left-5 bottom-5  sm:bottom-8 sm:right-8 lg:bottom-20 bg-white w-auto md:w-[603px] lg:flex-col gap-4 lg:gap-0  pt-5 pb-6 px-6 sm:p-6 lg:p-9 border-grayBorder border rounded-[28px] flex justify-center items-center">
            <img class="hidden sm:block" src="../../../images/cookie.png" />
            <div class="flex flex-col items-start lg:items-center">
                <h2 class="lg:mt-6 font-trap font-semibold text-2xl text-blackColor">Hi, we use cookies!</h2>
                <p class="text-sm text-left lg:text-center leading-[22px] text-gray lg:mb-6">Our website uses cookies.
                    By
                    continuing we assume
                    your
                    permission
                    to deploy cookies as detailed in our
                    <a class="text-mainColor" href="/privacy-policy">Privacy Policy.</a>
                </p>
            </div>
            <div class="flex space-y-2 my-5 w-full flex-wrap" v-if="showOptions">
                <div class="flex w-[45%] pointer items-center mr-2">
                    <input checked disabled id="checked-essential-checkbox" type="checkbox"
                        class="w-4 h-4 mr-1 focus:ring-offset-0 focus-visible:outline-none outline-none checked:text-transparent bg-transparent checked:border-mainColor focus:ring-transparent checked:border focus:outline-none focus:border-mainColor border-gray-300 rounded" />
                    <p class="text-gray text-sm">
                        Essential
                    </p>
                </div>
                <div class="flex w-[45%] pointer items-center mr-2">
                    <input aria-label="I Accept Terms and Conditions" id="checked-analytics-checkbox" type="checkbox"
                        v-model="isAnalyticsCheckboxChecked"
                        class="w-4 h-4 mr-1 focus:ring-offset-0 focus-visible:outline-none outline-none checked:text-transparent bg-transparent checked:border-mainColor focus:ring-transparent checked:border focus:outline-none focus:border-mainColor border-gray-300 rounded" />
                    <p @click="checkAnalyticsCheckbox" class="text-gray text-sm">
                        Analytics
                    </p>
                </div>
                <div class="flex w-[45%] pointer items-center mr-2">
                    <input aria-label="I Accept Terms and Conditions" id="checked-site-checkbox" type="checkbox"
                        v-model="isSitePreferencesCheckboxChecked"
                        class="w-4 h-4 mr-1 focus:ring-offset-0 focus-visible:outline-none outline-none checked:text-transparent bg-transparent checked:border-mainColor focus:ring-transparent checked:border focus:outline-none focus:border-mainColor border-gray-300 rounded" />
                    <p @click="checkSitePreferencesCheckbox" class="text-gray text-sm">
                        Site Preferences
                    </p>
                </div>
                <div class="flex w-[45%] pointer items-center mr-2">
                    <input aria-label="I Accept Terms and Conditions" id="checked-marketing-checkbox" type="checkbox"
                        v-model="isMarketingCheckboxChecked"
                        class="w-4 h-4 mr-1 focus:ring-offset-0 focus-visible:outline-none outline-none checked:text-transparent bg-transparent checked:border-mainColor focus:ring-transparent checked:border focus:outline-none focus:border-mainColor border-gray-300 rounded" />
                    <p @click="checkMarketingCheckbox" class="text-gray text-sm">
                        Marketing
                    </p>
                </div>
            </div>
            <div class="w-full sm:w-auto lg:w-full">
                <button @click="allowCookies"
                    class="btn-primary text-sm lg:text-[16px] mb-2 w-full uppercase md:w-[181px] lg:w-full">Accept</button>
                <button v-if="showOptions" @click="cookieSettings"
                    class="hover:bg-lightOrange flex w-full md:w-[181px] lg:w-full text-sm lg:text-[16px] items-center contact text-blackColor outline outline-1 h-12 font-bold contact-desctop text-sm p-2 outline-mainColor rounded-xl transition duration-200">
                    Save settings
                </button>
                <button v-if="!showOptions" @click="showSettings"
                    class="hover:bg-lightOrange flex w-full md:w-[181px] lg:w-full text-sm lg:text-[16px] items-center contact text-blackColor outline outline-1 h-12 font-bold contact-desctop text-sm p-2 outline-mainColor rounded-xl transition duration-200">
                    Cookie settings
                </button>
            </div>
        </div>
    </div>
</template>


<script>
export default {
    name: "CookiesPopup",
    data() {
        return {
            showBanner: false,
            showOptions: false,
            isAnalyticsCheckboxChecked: false,
            isMarketingCheckboxChecked: false,
            isSitePreferencesCheckboxChecked: false,
        };
    },
    methods: {
        allowCookies() {
            this.$cookies.set('cookies_accepted', 'true', { expires: 7 });
            this.showBanner = false;
            window.initCookieAllowedScripts()
        },
        showSettings() {
            this.showOptions = true
        },
        cookieSettings() {
            if (this.isMarketingCheckboxChecked || this.isAnalyticsCheckboxChecked) {
                if (this.isMarketingCheckboxChecked) {
                    this.$cookies.set('cookies_marketing_accepted', 'true', { expires: 7 });
                    this.$cookies.set('cookies_accepted', 'false', { expires: 7 });
                }
                if (this.isAnalyticsCheckboxChecked) {
                    this.$cookies.set('cookies_analytics_accepted', 'true', { expires: 7 });
                    this.$cookies.set('cookies_accepted', 'false', { expires: 7 });
                }
            } else {
                this.showBanner = false;
                this.$cookies.set('cookies_accepted', 'false', { expires: 7 });
            }
            this.showBanner = false;
            window.initCookieAllowedScripts()
        },
        handleMousemove() {
            this.showBanner = !this.$cookies.get('cookies_accepted');
        },
        checkSitePreferencesCheckbox() {
            this.isSitePreferencesCheckboxChecked = !this.isSitePreferencesCheckboxChecked
        },
        checkMarketingCheckbox() {
            this.isMarketingCheckboxChecked = !this.isMarketingCheckboxChecked
        },
        checkAnalyticsCheckbox() {
            this.isAnalyticsCheckboxChecked = !this.isAnalyticsCheckboxChecked
        }
    },
    created() {
        window.addEventListener('mousemove', this.handleMousemove);
    },
    beforeDestroy() {
        window.removeEventListener('mousemove', this.handleMousemove);
    },
};
</script>